module.exports = __webpack_public_path__ + "img/6.5a25e0b1.svg";